export const isPathExternal = path => {
  return path ? path.indexOf('http') === 0 || path.indexOf('mailto:') === 0 || path.indexOf('tel:') === 0 : false
}
